export default {
  newDesign: true,
  title: "Ответьте на несколько вопросов и получите приглашение на бесплатный IT-курс для ребёнка | Kodland",
  downtimeUrl: "https://www.kodland.org/ru",
  parameters: {
    landing_id: "CisQFC",
    segment: 1,
    success_page: 'cis_freetc_thankyou',
  },
  startPage: {
    title:
      "Ответьте на несколько вопросов и получите приглашение на бесплатный IT-курс для ребёнка",
    subtitle:
      "Вместе сделаем первый проект и покажем как превратить увлечение гаджетами в пользу на БЕСПЛАТНОМ курсе",
    image: {
      url: "/welcome/coding_freecourse_cis_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/coding_freecourse_cis_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Вперёд 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Спасибо, что доверяете нашей образовательной платформе!",
    subtitle:
      "К сожалению, планшеты и телефоны не подходят для прохождения наших уроков. Будем рады видеть вас на наших занятиях в следующий раз!",
  },
  quizRotateBySteps: {
    1: {
      question: "Сколько времени ребёнок проводит с гаджетами в день?",
      answers: [
        "😍 До 2-х часов",
        "😔 Больше 4-х часов",
        "😒 От 2-х до 4-х часов",
        "🤔 Не слежу за этим"
      ],
    },
    2: {
      question: "Какой характер у вашего ребёнка? Ответ поможет подобрать нам подходящего методиста для ребенка",
      answers: [
        "🗣️ Активный, много общается",
        "🐭 Застенчивый, часто зажимается",
        "⛅ Мечтательный, витает в облаках",
        "🙂 Тихоня, проводит время «в себе»",
        "🤔 Не знает, чего хочет",
        "😏 Свой вариант (расскажу на уроке)"
      ],
    },
    3: {
      question: "Как вы оцениваете мотивацию ребёнка учиться?",
      answers: [
        "😞 Низкая мотивация",
        "🙂 Нормальная",
        "😍 Высокая"
      ],
    },
    4: {
      title: "Сколько лет вашему ребёнку?",
      type: "age",
      button: "",
    },
    5: {
      question:
        "У вас есть компьютер или ноутбук? (для обучения не подойдут телефоны, планшеты и устройства без клавиатуры и мыши)",
      answers: [
        "😉 Да",
        {
          answer: "🤔 Нет",
          stopAnswer: true,
        },
      ],
    },
    6: {
      question: "Как вы думаете,  что ребёнку будет интереснее всего изучать и создавать на бесплатном курсе?",
      answers: [
        "🎨 Иллюстрации для игр, кино, приложений",
        "🖼️ Авторские анимации с 3D-моделями и иллюстрациями",
        "🌐 Сайты (портфолио, визитка)",
        "🎮 Популярную игру",
        "🫂 Приложение, которое будет помогать людям"
      ],
    },
    7: {
      title: "Поздравляем! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Чтобы завершить регистрацию на бесплатный онлайн-курс, выберите дату и время для первого урока.",
      button: "Выбрать дату",
    },
    8: {
      title: "Завершите регистрацию",
      type: "one-page-contacts",
      subtitle: "",
      button: "Последний шаг 🔥",
    },
    9: {
      title: "Выберите удобный день для первого урока",
      type: "timeslot",
      subtitle: "",
      button: "",
    }
  },
};
